
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },

  computed: {
    outerStyles() {
      const styles = {}

      styles.paddingBottom = `calc(100% / calc(${this.getBreakpointValue(
        this.blok.aspectRatio
      )}))`

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      // media query context
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // executes desktop only - lg breakpoint
      mm.add('(min-width: 1024px)', () => {
        this.initAnimation()
      })
    })
  },
  methods: {
    initAnimation() {
      this.$gsap.from('path', {
        drawSVG: 0,
        duration: 5,
      })

      this.$gsap.from('.svg-image', {
        opacity: 0,
        scale: 0.9,
        transformOrigin: 'center center',
        duration: 0.8,
        stagger: 0.3,
        delay: 0.3,
      })

      // parallax
      // const tl = this.$gsap.timeline({
      //   scrollTrigger: {
      //     trigger: this.$refs.container,
      //     start: 'top top',
      //     end: 'bottom top',
      //     scrub: true,
      //   },
      // })

      // this.$gsap.utils.toArray('.parallax').forEach((layer) => {
      //   const depth = layer.dataset?.depth
      //   const movement = -(
      //     layer.firstChild.getBoundingClientRect()?.height * depth
      //   )
      //   tl.to(layer, { y: movement, ease: 'none' }, 0)
      // })

      // this.$gsap.set(['.aspot-img'], {
      //   opacity: 0,
      //   scale: 0.9,
      //   transformOrigin: 'center center',
      // })
      // this.$gsap.to(['.aspot-img'], {
      //   opacity: 1,
      //   scale: 1,
      //   // y: 0,
      //   duration: 0.8,
      //   stagger: 0.3,
      //   delay: 0.3,
      // })
    },
  },
}
